// extracted by mini-css-extract-plugin
export var hideEditor = "_k3-2";
export var infoIcon = "_k3-3";
export var label = "_k3-1";
export var labelContainer = "_k3-0";
export var readonlyText = "_k3-4";